import { render, staticRenderFns } from "./AddDockingStation.vue?vue&type=template&id=a85e6f7e&scoped=true&lang=pug&"
import script from "./AddDockingStation.vue?vue&type=script&lang=js&"
export * from "./AddDockingStation.vue?vue&type=script&lang=js&"
import style0 from "./AddDockingStation.vue?vue&type=style&index=0&id=a85e6f7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85e6f7e",
  null
  
)

export default component.exports